import { storeApi } from '@shared/config/axios';

export default {
  getBundle(slug) {
    return storeApi.$get(`/bundles/${slug}`);
  },
};
